import { render } from "./DuplicateTrim.vue?vue&type=template&id=4645f908"
import script from "./DuplicateTrim.vue?vue&type=script&lang=js"
export * from "./DuplicateTrim.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__